import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { Field } from 'src/API';
import { FieldInput } from 'src/api/process-module';
import { TEST_IDS } from 'src/test-ids';
import { BaseFieldWrapper } from '../preview/BaseFieldWrapper';

export interface StatusFieldProps {
  field: FieldInput & Partial<Field>;
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  index?: number;
  handleFieldChange?: (index: number, field: FieldInput & Partial<Field>) => void;
  isSubmitting?: boolean;
  isUsingExistingField?: boolean;
}

const STATUS_OPTIONS = [
  { name: 'Not started', label: 'Not started' },
  { name: 'In progress', label: 'In progress' },
  { name: 'Completed', label: 'Completed' },
  { name: 'Not applicable', label: 'Not applicable' },
];

export const StatusField: React.FC<StatusFieldProps> = ({
  field,
  value = '',
  onChange,
  disabled = false,
  index,
  handleFieldChange,
  isSubmitting,
  isUsingExistingField,
}) => {
  const options = STATUS_OPTIONS;

  const handleChange = (event: SelectChangeEvent<string>) => {
    if (onChange) onChange(event.target.value);
    if (handleFieldChange && typeof index === 'number') {
      handleFieldChange(index, {
        ...field,
        dataSource: event.target.value,
      });
    }
  };

  const validValue = options.find((option) => option.name === value);

  console.log('🎛️ StatusField render:', {
    receivedValue: value,
    validValue: validValue?.name,
    fallbackValue: options[0].name,
    finalSelectValue: validValue ? validValue.name : options[0].name,
    allOptions: options.map((o) => o.name),
  });

  return (
    <BaseFieldWrapper label={field.label} required={false} fieldProps={undefined}>
      <FormControl fullWidth>
        <Select
          value={validValue ? validValue.name : options[0].name}
          onChange={handleChange}
          // disabled={disabled || isSubmitting || isUsingExistingField}
          displayEmpty
          data-testid={TEST_IDS.FORM_VIEW.STATUS_SELECT}
        >
          <MenuItem value="">
            <em>Select status</em>
          </MenuItem>
          {options.map((option) => (
            <MenuItem key={option.name} value={option.name}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </BaseFieldWrapper>
  );
};
